import React from "react"
import ReactDOM from "react-dom"
import { connect } from "react-redux"
import { H4 } from "@infotech/uikit-text"
import { RefreshDataIcon } from "@infotech/uikit-icons"
import { Flex, ContentCell } from "src/components/Grid"
import { Div } from "@infotech/uikit-grid"
import CloseIcon from "src/icons/close.svg"
import classnames from "classnames"
import { selectValue } from "src/engine/modules/ui/selectors"
import { SIDEBAR_WIDTH, SIDEBAR_COMPACT_WIDTH } from "src/engine/modules/ui"
import withModalSetup from "../hocs/withModalSetup"

import styles from "./styles.css"

const mapStateToProps = state => ({
  isMenuVisible: selectValue(state, `isMenuVisible`),
  areMenuCaptionsVisible: selectValue(state, `areMenuCaptionsVisible`),
})

class Modal extends React.Component {
  componentDidMount() {
    const { fullWidth } = this.props

    if (fullWidth) {
      window.addEventListener(`resize`, this.rerender, false)
    }
  }

  componentWillUnmount() {
    const { fullWidth } = this.props

    if (fullWidth) {
      window.removeEventListener(`resize`, this.rerender, false)
    }
  }

  rerender = () => this.forceUpdate()

  render() {
    const {
      isModalMounted,
      title,
      children,
      isOpen,
      pending,
      onCancel,
      onRefresh,
      fullWidth,

      // TODO remove, when uikit-select start to support
      // popup-factory, so select dropdowns are rendered above
      // buttons
      fullHeight = true,
      width,
      containerDomNode,
      buttonReactNodes,
      isMenuVisible,
      areMenuCaptionsVisible,
      noFooter,
      hasOverlay,
    } = this.props
    if (!isOpen) {
      return null
    }

    const style = {}
    if (width && !fullWidth) {
      style.width = `${width}px`
    } else if (fullWidth) {
      const getSubtrahend = () => {
        if (isMenuVisible && areMenuCaptionsVisible) {
          return SIDEBAR_WIDTH + 1
        }
        if (isMenuVisible) {
          return SIDEBAR_COMPACT_WIDTH + 1
        }
        return 0
      }

      style.width = `${document.body.clientWidth - getSubtrahend()}px`
    }

    const footer = !noFooter && (
      <Flex className={styles[`modal-footer-wrapper`]} bt bb>
        {buttonReactNodes}
      </Flex>
    )

    return ReactDOM.createPortal(
      <>
        <div
          className={classnames(styles[`modal-wrapper`], {
            [styles[`full-width`]]: fullWidth,
          })}
          style={style}
        >
          <Flex bb className={styles[`modal-title-wrapper`]}>
            <ContentCell flex className={styles[`modal-title-wrapper-2`]}>
              <H4 className={styles[`modal-title`]}>{title}</H4>
            </ContentCell>
            <ContentCell className={styles[`modal-header-buttons`]}>
              {!pending && onRefresh && (
                <div onClick={onRefresh} className={styles[`close-icon`]}>
                  <RefreshDataIcon color="#317dff" />
                </div>
              )}
              {onCancel && (
                <div onClick={onCancel} data-testid="close-entity-modal-icon">
                  <CloseIcon size="medium" className={styles[`close-icon`]} />
                </div>
              )}
            </ContentCell>
          </Flex>
          {/* TODO - change id on ref and refactor similar situations */}
          <Flex
            column
            id="IdForResourceTypeDnDScroll"
            className={styles[`modal-main-wrapper`]}
          >
            <Flex
              column
              className={classnames({
                [styles[`full-height`]]: fullHeight && !noFooter,
                [styles[`full-height-no-footer`]]: fullHeight && noFooter,
              })}
            >
              {isModalMounted ? children : null}
            </Flex>
          </Flex>
          {footer}
          {fullHeight || (
            <Flex className={styles[`modal-bottom-space-eater`]} />
          )}
        </div>
        {hasOverlay && <Div className={styles.Overlay} />}
      </>,
      containerDomNode,
    )
  }
}

export default connect(mapStateToProps)(withModalSetup(Modal))
